export const setCookie = (cName, val, exdays) => {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    const value = escape(val) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = cName + "=" + value;
};

export const getCookie = (cName) => {
    let value = document.cookie;
    let start = value.indexOf(" " + cName + "=");
    if (start == -1) {
        start = value.indexOf(cName + "=");
    }
    if (start == -1) {
        value = null;
    } else {
        start = value.indexOf("=", start) + 1;
        let end = value.indexOf(";", start);
        if (end == -1) {
            end = value.length;
        }
        value = unescape(value.substring(start, end));
    }
    return value;
};
